var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeshape6A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new_eyes__x2F__eyebrows"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eyes_x5F_3a"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8F3",
    d: "M410.8,255.6c-9.9-2.3-21.4,3.2-27.8,12.1c-1.5,2.4-3.2,5.3-2.2,7.3c1.4,2.6,3,4.4,5.6,6.4 c5.8,4.3,15.4,5,21.5,3.4c3.3-0.9,5.3-2.2,8.1-4.3c2.1-1.6,3.4-3.4,4.4-5.5C422.7,267,420.6,257.9,410.8,255.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3D3836",
    d: "M400.8,257c-7-0.9-13.3,3.9-14.2,10.6c-0.9,6.7,4.1,12.9,11.1,13.8s13.3-3.9,14.2-10.6 C412.8,264.1,407.8,257.9,400.8,257z M397.8,281c-6.7-0.9-11.5-6.8-10.7-13.3s7-11.1,13.7-10.2s11.5,6.8,10.7,13.3 C410.6,277.3,404.5,281.8,397.8,281z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7192BC",
    d: "M400.8,257.4c-6.7-0.9-12.9,3.7-13.7,10.2c-0.8,6.5,4,12.5,10.7,13.3c6.7,0.9,12.9-3.7,13.7-10.2 C412.3,264.3,407.5,258.3,400.8,257.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#16151C",
    d: "M406,270.2c-0.5,3.8-4.1,6.5-8,6c-4-0.5-6.8-4-6.3-7.8s4.1-6.5,8.1-6C403.7,262.9,406.5,266.4,406,270.2z "
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1266 -0.992 0.992 0.1266 79.3 622.7656)",
    opacity: 0.73,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    cx: 393.3,
    cy: 266.4,
    rx: 3.8,
    ry: 4
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4F3827",
    d: "M422.6,260.8c6.4,0.2,9.2-10,7.4-15.1c-0.7,5.5-4.6,10.7-8.5,11.6c-1.5-2.6-7.4-5.1-10-5.7 c-4.7-1-9.9-0.5-14.4,1.2c-7,2.6-12.5,9.1-15.9,16.1c-1.3,2.2-2.1,4.6-1,6.6c1.4,2.7,3.1,4.6,5.9,6.6c3,2.2,7,3.5,11.1,4.1 c4,0.5,8,0.3,11.1-0.5c3.5-0.9,5.6-2.4,8.4-4.5c5-4.1,7.7-9,8-15.1c3.7,3,10.4-1.3,11.4-5.3C431.9,263.6,426.6,263.4,422.6,260.8z  M416.1,280.5c-2.9,2.1-4.8,3.5-8.1,4.3c-6.1,1.6-15.7,0.9-21.5-3.4c-2.6-2-4.2-3.7-5.6-6.4c-1.1-2,0.7-4.9,2.2-7.3 c6.3-8.9,17.8-14.4,27.8-12.1c9.8,2.3,12,11.4,9.7,19.3C419.5,277,418.2,278.9,416.1,280.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8F3",
    d: "M303.4,255.6c9.9-2.3,21.4,3.2,27.8,12.1c1.5,2.4,3.2,5.3,2.2,7.3c-1.4,2.6-3,4.4-5.6,6.4 c-5.8,4.3-15.4,5-21.5,3.4c-3.3-0.9-5.3-2.2-8.1-4.3c-2.1-1.6-3.4-3.4-4.4-5.5C291.5,267,293.6,257.9,303.4,255.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3D3836",
    d: "M302.3,270.8c0.9,6.7,7.2,11.5,14.2,10.6s11.9-7.1,11.1-13.8c-0.9-6.7-7.2-11.5-14.2-10.6 S301.4,264.1,302.3,270.8z M302.7,270.8c-0.8-6.5,4-12.5,10.7-13.3c6.7-0.9,12.9,3.7,13.7,10.2c0.8,6.5-4,12.5-10.7,13.3 S303.5,277.3,302.7,270.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7192BC",
    d: "M313.4,257.4c6.7-0.9,12.9,3.7,13.7,10.2c0.8,6.5-4,12.5-10.7,13.3c-6.7,0.9-12.9-3.7-13.7-10.2 C301.9,264.3,306.7,258.3,313.4,257.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#16151C",
    d: "M308.2,270.2c0.5,3.8,4.1,6.5,8,6c4-0.5,6.8-4,6.3-7.8s-4.1-6.5-8.1-6 C310.5,262.9,307.7,266.4,308.2,270.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.992 -0.1266 0.1266 0.992 -31.1441 42.7696)",
    opacity: 0.73,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    cx: 320.9,
    cy: 266.4,
    rx: 4,
    ry: 3.8
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4F3827",
    d: "M278.2,260.8c1,4,7.7,8.3,11.4,5.3c0.2,6.1,2.9,11,8,15.1c2.8,2.1,5,3.6,8.4,4.5c3.1,0.8,7.1,1.1,11.1,0.5 c4-0.5,8.1-1.8,11.1-4.1c2.7-2,4.4-3.9,5.9-6.6c1.1-2,0.2-4.4-1-6.6c-3.4-7.1-8.8-13.6-15.9-16.1c-4.5-1.6-9.7-2.2-14.4-1.2 c-2.6,0.6-8.5,3-10,5.7c-3.9-0.9-7.8-6.1-8.5-11.6c-1.8,5.2,1,15.4,7.4,15.1C287.6,263.4,282.3,263.6,278.2,260.8z M293.7,274.9 c-2.2-7.9-0.1-17,9.7-19.3c9.9-2.3,21.4,3.2,27.8,12.1c1.5,2.4,3.2,5.3,2.2,7.3c-1.4,2.6-3,4.4-5.6,6.4c-5.8,4.3-15.4,5-21.5,3.4 c-3.3-0.9-5.3-2.2-8.1-4.3C296,278.9,294.7,277,293.7,274.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeshape6A);
export default __webpack_public_path__ + "static/media/eyeshape_6a.04e83f37ab678181515346e282723e6f.svg";
export { ForwardRef as ReactComponent };